<template>
    <div class="view-product-page">
        <fancy-header></fancy-header>
        <div class="container">
            <div class="loading getmore-div" v-show="isLoading">
                <div class="fas fa-spinner fa-spin" >
                </div>
            </div>
            <div class="row" v-show="!isLoading">
                <div class="col-xs-12">
                    <ol class="breadcrumb">
                        <li><a @click="view('home')">الرئيسية</a> <span class="fa fa-home"
                                                                        style="float:right;color:#ffbb02;margin-top:2px;"></span>
                        </li>
                        <li><router-link :to="{ name: 'products' }">المنتجات</router-link></li>
                        <li><router-link :to="{ name: 'products', params: { section: product.Section.Title }}">{{ product.Section.Title }}</router-link></li>
                        <li class="active">{{ product.Title }}</li>
                    </ol>
                      
                </div>
                <div class="col-xs-12 product-container">
                    <div class="product-image">
                        <div class="img-container">
                            <div class="content">
                                <img :src="product.PrimaryImage.Url">
                            </div>
                            
                        </div>
                    </div>
                    <div class="product-content">
                        <div class="title-section">
                            <h2>{{ product.Title }}</h2>
                        </div>
                        <div class="meta-section">
                            <p><span class="fa fa-dedent"></span><span>{{ product.Section.Title }}</span></p>
                            <p><span class="fa fa-eye"></span><span>{{ product.Views }}</span><span>مشاهدة</span></p>
                        </div>
                        <div class="product-description" v-html="product.Description">
                        </div>
                    </div>
                    
                </div>
            </div>

        </div>
        <gallery v-if="product.Images.length !== 0" :Images="product.Images"></gallery>
        <related-products ref="relatedProducts" v-show="!isLoading" :product-id="id"></related-products>
    </div>
</template>
<script>
    import FancyHeader from '@/components/shared/fancy-header'
    import RelatedProducts from '@/components/products/related-products'
    import Gallery from '@/components/products/gallery'

    export default {
        name: 'ViewProduct',

        data: () => ({
            id: 0,
            isLoading: false,

             product: {
                Title:null,
                Description: null,
                Views: null,
                Section: {
                    Title: null
                },
                PrimaryImage: {
                    Url: null
                },
				Images: []
            }
        }),

        methods: {
            view(route) {
                this.$router.push({
                    name: route
                });
            },
            initLightGallery(){
                $(document).ready(function() {
                            $("#lightgallery").lightGallery(); 
                    });
            },
            showPricingOrderModal() {
                this.$refs.pricingOrderModal.showModal(this.id);
            },

            onLoad() {
                this.id = this.$route.params.id;
                this.isLoading = true;
                
                axios.get(apiHost + "/products/" + this.id)
                    .then((response) => {
                        this.product = response.data;
                        this.$refs.relatedProducts.fetch(this.product.SectionId);
                        this.initLightGallery();
                    }).finally(() => this.isLoading = false);
            }
        },

        mounted() {
            this.onLoad();
            $(document).ready(function(){
                $('.product-description  p *').css({"font-family":"changa"});
            });
        },

        watch: {
            '$route' (to, from) {
                this.onLoad();
            }
        },

        components: {
            FancyHeader,
            RelatedProducts,
            Gallery
        }
    }
</script>
<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .view-product-page {
        & > .container {
            margin-top: 30px;
            margin-bottom: 30px;
        }
        direction: $dir;
        @include text-align($dir);
        .breadcrumb {
            li {
                span.fa {
                    @include margin-right(10px, $dir);
                }
                a {
                    &:hover, &:focus {
                        color: $main-color;
                        text-decoration: none;
                    }
                }
            }
        }
        .product-container {
            .product-image {
                @include margin-left(30px,$dir);
                @include float-right($dir);
                border-radius: 10px;
                border: 2px solid #fff;
                width: 25%;
                @media (max-width: 767px) {
                    width: 30%;
                }
                @media(max-width: 480px) {
                    width: 100%;
                    clear:both;
                    margin-bottom:20px;
                }
                .img-container {
                    width: 100%;
                    @include aspect-ratio(1,1);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .product-content {
               
                .title-section {
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
                .meta-section {
                    p {
                        direction: $dir;
                        span {
                            @include margin-right(10px, $dir);
                            &.fa {
                                color: #ccc;
                            }
                        }

                    }
                }
                .product-description {
                    direction: $dir;
                    @include text-align($dir);
                    font-size: 18px;
                }
                
            }
        }

         .order-button-container {
                    margin-top:15px;
                    .btn {
                        span.fa {
                            @include margin-right(10px, $dir);
                        }
                    }
                }
        .loading.getmore-div{
            text-align:center;
            margin-top:15px;
            height: 200px;
            .fa-spin{
                font-size:20px;
                color:$main-color;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/products/view-product.vue